import useFetch from '@/js/hooks/api/useFetch'
import { get } from '@/js/utils/helpers'
import { computed, ref, Ref } from 'vue'
import { IReportExport } from '@/js/utils/types'
import { UseFetchOptions } from '@mumble/hooks/vue/useFetch'

const POLLING_INTERVAL_MS = 5000
// The backend closes stale exports after 20 minutes: stop polling shortly after that
const POLLING_TIMEOUT_MS = 21 * 60 * 1000

export default function useReportExportFetch(exportId: Ref<string | undefined>, opts?: UseFetchOptions) {
    const startedAt = Date.now()
    const isTimedOut = ref(false)

    const { isLoading, isError, alert, data } = useFetch(
        ['report-export', exportId],
        () => get<IReportExport>(`reports/export/${exportId.value}`),
        // The vendored options type does not declare refetchInterval and reactive enabled, both supported by vue-query
        {
            ...opts,
            enabled: computed(() => !!exportId.value),
            refetchOnWindowFocus: false,
            refetchInterval: (res?: IReportExport) => {
                if (res && (res.status === 'done' || res.status === 'failed')) return false
                if (Date.now() - startedAt > POLLING_TIMEOUT_MS) {
                    isTimedOut.value = true
                    return false
                }

                return POLLING_INTERVAL_MS
            },
        } as UseFetchOptions
    )

    return {
        isLoading,
        isError,
        alert,
        isTimedOut,
        reportExport: data as Ref<IReportExport | undefined>,
    }
}
